<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="1200px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ $t("email.ListSend") }}
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            style="float: right"
            @click="Fn_Close()"
          >
            {{ $t("consentform.close") }}
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="DataList"
            hide-default-footer
            :items-per-page="rowPerpage"
            class="pa-5"
          >
            <template v-slot:[`item.Status`]="{ item }">
              <v-chip v-if="item.Status == 'OK'" color="#388E3C" dark>
                {{ $t("onechat.statusSendMail") }}
              </v-chip>
              <v-chip v-if="item.Status == 'ER'" color="#B71C1C" dark>
                {{ $t("onechat.status3") }}
              </v-chip>
              <v-chip v-if="item.Status == 'Read'" color="warning" dark>
                {{ $t("onechat.status7") }}
              </v-chip>
            </template>
            <template v-slot:[`item.Tel`]="{ item }">
              <div v-if="item.Tel.length === 0 || item.Tel === ''">-</div>
              <div v-else>{{ item.Tel }}</div>
            </template>
            <template v-slot:[`item.Note`]="{ item }">
              <div class="red--text">{{ item.ErrorMessage }}</div>
            </template>
          </v-data-table>
        </v-card-text>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
import Swal2 from "sweetalert2/dist/sweetalert2.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  props: ["show", "_detail"],
  data: function () {
    return {
      rowPerpage: 10,
      btnSendLoading: false,
      DataList: [],
      serviceEmail: "",
    };
  },
  created() {},
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "row",
            sortable: false,
          },
          // {
          //   text: this.$i18n.t("consentlist.topic"),
          //   value: "PolicyHeader",
          //   sortable: false,
          // },
          // {
          //   text: this.$i18n.t("consentlist.subject"),
          //   value: "ConsentHeader",
          //   sortable: false,
          // },
          {
            text: this.$i18n.t("onechat.name"),
            value: "Name",
            sortable: false,
          },
          {
            text: this.$i18n.t("Profile.email"),
            value: "Email",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.status"),
            value: "Status",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.Note"),
            value: "Note",
            sortable: false,
          },
        ];
      },
    },
    _SendId: {
      get() {
        return this.DataGroupConsent.SendId || "-";
      },
    },
  },
  watch: {
    show(val) {
      if (val == true) {
        this.DataList = this._detail;
        this.fn_setData();
      }
    },
  },
  mounted() {},
  methods: {
    fn_setData() {
      for (var i in this.DataList) {
        this.DataList[i]["row"] = parseInt(i) + 1;
      }
    },
    Fn_Close() {
      this.$emit("closeDialogDelete");
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}
</style>
